import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { get } from 'lodash'
import { connect } from 'react-redux'
import { HeaderItem } from 'components/misc'
import { UserGuideModal } from 'components/modals'
import MODALS from 'constants/layout/modals'
import { modal } from 'helpers/decorators'
import { apiConfiguration } from '../../../helpers/decorators/api'
import { CONFIGURATION_KEYS } from '../../../constants/enums'

@modal.trigger()
@apiConfiguration()
@connect(({ api }) => ({
  award: get(api, 'dashboard.awards.awards.data')
}))
class UserGuide extends Component {
  static propTypes = {
    onOpen: PropTypes.func.isRequired,
    award: PropTypes.object,
    onlyTrigger: PropTypes.bool,
    onGetConfigurationValue: PropTypes.func,
    configuration: PropTypes.object
  }

  componentDidMount() {
    const orgId = get(this.props.award, 'organization.id')

    Promise.all([
      this.props.onGetConfigurationValue(CONFIGURATION_KEYS.privacyPolicyCheck.id, orgId),
      this.props.onGetConfigurationValue(CONFIGURATION_KEYS.privacyPolicyText.id, orgId)
    ])
  }

  render() {
    const { onlyTrigger, configuration } = this.props

    const policyTextObj = get(configuration, `values[${CONFIGURATION_KEYS.privacyPolicyText.id}]`)

    const hasPolicy = get(configuration, `values[${CONFIGURATION_KEYS.privacyPolicyCheck.id}].booleanValue`, false)

    const policyText = get(policyTextObj, 'translatedText') || get(policyTextObj, 'textValue')

    return (
      <div>
        <HeaderItem
          ico="info"
          caption="User guide"
          captionKey="label.user_guide"
          onClick={() => this.props.onOpen(MODALS.USER_GUIDE)}
        />

        {!onlyTrigger && policyText &&
          <UserGuideModal
            modalId={MODALS.USER_GUIDE}
            award={this.props.award}
            hasPolicy={hasPolicy}
            policyText={policyText}
          />}
      </div>
    )
  }
}

export default UserGuide
